import {
  ANTHROPIC_CONTEXT_LIMIT_PATTERNS,
  ANTHROPIC_MODEL_EFFORTS,
} from "../anthropic/manifest";
import type { CredentialField, PackedCredentials } from "../manifest";
import { defineAIProviderManifest } from "../manifest";
import {
  OPENAI_CONTEXT_LIMIT_PATTERNS,
  OPENAI_MODEL_EFFORTS,
} from "../openai/manifest";

const credentialFields: readonly CredentialField[] = [
  {
    key: "apiKey",
    label: "API key",
    description: "Supplied by the connector.",
    placeholder: "",
    sensitive: true,
    required: true,
  },
];

const packCredentials = () => ({ baseUrl: "", apiKey: "" });

const unpackCredentials = (row: PackedCredentials) => ({
  baseUrl: row.baseUrl,
});

const attachmentSupport = {
  documentMediaTypes: ["application/pdf"],
  maxImageDimension: 2000,
};

export const OPENAI_CONNECTOR_IDENTIFIER = "microsoftFoundryOpenai";

export const manifest = defineAIProviderManifest({
  id: "microsoft-foundry",
  label: "Microsoft Foundry",
  description:
    "Connect to Claude, GPT, Grok, DeepSeek, and Llama deployments on a Microsoft Foundry resource, formerly Azure AI Foundry. Requires a Foundry connector and deployment names.",
  connectorIdentifier: "microsoftFoundryClaude",
  endpointFromConnector: true,
  defaultChatModel: "claude-opus-5",
  defaultFastModel: "claude-haiku-4-5",
  defaultChatEffort: "low",
  modelEfforts: [...ANTHROPIC_MODEL_EFFORTS, ...OPENAI_MODEL_EFFORTS],
  configurable: true,
  requiresChatModel: true,
  contextLimitPatterns: [
    ...ANTHROPIC_CONTEXT_LIMIT_PATTERNS,
    ...OPENAI_CONTEXT_LIMIT_PATTERNS,
  ],
  reasoningReplay: { via: "signature", providerOptionsKey: "anthropic" },
  credentialFields,
  packCredentials,
  unpackCredentials,
  subtitleField: "baseUrl",
  attachmentSupport,
});
